import { ComponentStyleConfig } from "@chakra-ui/react";

const Button: ComponentStyleConfig = {
  baseStyle: { borderRadius: "none" },
  variants: {
    outline: ({ colorScheme }) => ({
      color: "chakra-body-text",
      borderColor: `${colorScheme}.500`,
      borderWidth: "2px",
      "&:hover:not(:disabled)": {
        bg: `${colorScheme}.500`,
        color: "white",
      },
    }),
    secondary: () => ({
      color: "chakra-body-text",
      borderColor: "gray.300",
      borderWidth: "1px",
      bg: "white",
      "&:hover:not(:disabled)": {
        bg: "gray.50",
      },
    }),
  },
  defaultProps: { variant: "outline" },
};

export default Button;
